import { createSearchResultListItemExtension } from '@backstage/plugin-search-react';
import { SearchClient } from './api/search-client';
import { searchApiRef } from './api/search-api';
import {
  createApiFactory,
  createPlugin,
  createRouteRef,
  createRoutableExtension,
  discoveryApiRef,
  createComponentExtension,
  fetchApiRef,
} from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'customsearch',
});

/**
 * @public
 */
export const searchPlugin = createPlugin({
  id: 'customsearch',
  apis: [
    createApiFactory({
      api: searchApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) => {
        return new SearchClient({ discoveryApi, fetchApi });
      },
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

/**
 * @public
 */
export const CustomSearchPage = searchPlugin.provide(
  createRoutableExtension({
    name: 'CustomSearchPage',
    component: () =>
      import('./components/CustomSearchPage').then(m => m.CustomSearchPage),
    mountPoint: rootRouteRef,
  }),
);

/**
 * @public
 */
export const CustomSearchBar = searchPlugin.provide(
  createRoutableExtension({
    name: 'CustomSearchBar',
    component: () =>
      import('./components/CustomSearchBar').then(m => m.CustomSearchBar),
    mountPoint: rootRouteRef,
  }),
);

/**
 * @public
 */
export const CustomSearchResult = searchPlugin.provide(
  createRoutableExtension({
    name: 'CustomSearchResult',
    component: () =>
      import('./components/CustomSearchResult').then(m => m.CustomSearchResult),
    mountPoint: rootRouteRef,
  }),
);
/**
 * @public
 */
export const CustomHomePageSearchBar = searchPlugin.provide(
  createComponentExtension({
    name: 'CustomHomePageSearchBar',
    component: {
      lazy: () =>
        import('./components/CustomHomePageSearchBar').then(
          m => m.CustomHomePageSearchBar,
        ),
    },
  }),
);

// In this package you might for example export components or hooks
// that are useful to other plugins or modules.

export const marketplaceSearchResultListItemPlugin = createPlugin({
  id: 'marketplace-search-result-list-item',
});

export const handbookSearchResultListItemPlugin = createPlugin({
  id: 'handbook-search-result-list-item',
});

export const catalogSearchResultListItemPlugin = createPlugin({
  id: 'catalog-search-result-list-item',
});
export const techdocsSearchResultListItemPlugin = createPlugin({
  id: 'techdocs-search-result-list-item',
});

export const MarketplaceSearchResultListItem =
  marketplaceSearchResultListItemPlugin.provide(
    createSearchResultListItemExtension({
      name: 'MarketplaceSearchResultListItem',
      component: () =>
        import('../src/components/MarketplaceSearchResultListItem').then(
          m => m.MarketplaceSearchResultListItem,
        ),
      // Only results matching your type will be rendered by this extension
      predicate: (result: { type: string }) => result.type === 'marketplace',
    }),
  );

export const HandbookSearchResultListItem =
  handbookSearchResultListItemPlugin.provide(
    createSearchResultListItemExtension({
      name: 'HandbookSearchResultListItem',
      component: () =>
        import('../src/components/HandbookSearchResultListItem').then(
          m => m.HandbookSearchResultListItem,
        ),
      // Only results matching your type will be rendered by this extension
      predicate: (result: { type: string }) => result.type === 'handbook',
    }),
  );

export const CatalogSearchResultListItem =
  catalogSearchResultListItemPlugin.provide(
    createSearchResultListItemExtension({
      name: 'CatalogSearchResultListItem',
      component: () =>
        import('../src/components/CatalogSearchResultListItem').then(
          m => m.CatalogSearchResultListItem,
        ),
      // Only results matching your type will be rendered by this extension
      predicate: (result: { type: string }) =>
        result.type === 'software-catalog',
    }),
  );

export const TechdocsSearchResultListItem =
  techdocsSearchResultListItemPlugin.provide(
    createSearchResultListItemExtension({
      name: 'TechdocsSearchResultListItem',
      component: () =>
        import('../src/components/TechdocsSearchResultListItem').then(
          m => m.TechdocsSearchResultListItem,
        ),
      // Only results matching your type will be rendered by this extension
      predicate: (result: { type: string }) => result.type === 'techdocs',
    }),
  );
